import {PageHeading} from "@ui-components/Container";
import {FormattedMessage, useIntl} from "react-intl";
import React, {useContext, useMemo, useState} from "react";
import {useHomeLinks} from "../hooks/useHomeLinks";
import MaterialTable from "@material-table/core";
import {tableIcons} from "@ui-components/TableIcons";
import TableStyle from "@components/TableStyle";
import {getColumns, LOCALIZATION, OPTIONS} from "./lib/consts";
import {HomeLink} from "@feature/home/types";
import CountryContext from "../../../CountryContext";
import {PlusCircleIcon} from "@heroicons/react/24/solid";
import Button from "@ui-components/Button";
import _ from "lodash";
import useRoleTypes from "@ui-components/pages/Users/hooks/useRoleTypes";

const HomeLinksEditor = () => {

  // context
  const {country: {code: countryCode}} = useContext(CountryContext);

  // hooks
  const intl = useIntl();
  const {loading, data, create, update, move, remove} = useHomeLinks(true);
  const roles = useRoleTypes() as unknown as any[] | null;

  // utilities
  const tableRef = React.useRef<MaterialTable<HomeLink>>(null);
  const columns = useMemo(
    () => getColumns(intl, countryCode, roles?.map((r) => r.name) ?? []),
    [intl, countryCode, roles]
  );

  return <>
    <PageHeading
      title={intl.formatMessage({id: "home_links", defaultMessage: "Home Links"})}
      contentActions={(
        <Button onClick={() => {
          // @ts-ignore
          const dm = tableRef.current?.dataManager;
          dm.changeRowEditing();
          tableRef.current?.setState({
            ...dm.getRenderState(),
            showAddRow: true,
          });
        }}>
          <PlusCircleIcon className="w-4 mr-1" />
          <FormattedMessage id="add" defaultMessage="Aggiungi"/>
        </Button>
      )}
    />
    <TableStyle>
      <MaterialTable
        tableRef={tableRef}
        columns={columns}
        data={data}
        icons={tableIcons}
        isLoading={loading}
        options={OPTIONS}
        localization={LOCALIZATION}
        editable={{
          onRowAdd: async (newData) => {
            await create(newData);
          },
          onRowUpdate: async (newData, oldData) => {
            if (_.isEqual(newData, oldData) || !oldData)
              return Promise.resolve();  // Do nothing if no changes
            await update(oldData.id, newData);
            if (newData.order !== oldData.order) {
              // If order changed, call move to reorder other links. This will reload the entire list.
              await move(oldData.id, newData.order);
            }
          },
          onRowDelete: async (oldData) => {
            await remove(oldData.id);
          }
        }}
      />
    </TableStyle>
  </>
}

export default HomeLinksEditor;